import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EntidadResponsableService } from '../../entidad-responsable/entidad-responsable.service';

@Component({
  selector: 'app-eliminar-entidad-responsable-dialog',
  templateUrl: './eliminar-entidad-responsable-dialog.component.html',
  styleUrls: ['./eliminar-entidad-responsable-dialog.component.scss']
})
export class EliminarEntidadResponsableDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  usuario: string = null;

  constructor(
    public dialogEliminar: MatDialogRef<EliminarEntidadResponsableDialog>,
    private entidadResponsableService: EntidadResponsableService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.cargando = true;
    this.entidadResponsableService.getEntidadResponsables(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdUsuResponsable: this.data.IdEntidadResponsable
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var responsable = respuesta.data.responsables[0];
          if (responsable) {
            this.usuario = responsable.usuario.usuario;
          } else {
            this.error = "Es posible que ya no exista en la base de datos";
          }
        }

        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    );
  }

  onCancelar(): void {
    this.dialogEliminar.close();
  }

  onEliminar(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;
      this.entidadResponsableService.eliminarResponsableEntidad(this.data.IdEntidadResponsable).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.dialogEliminar.close(respuesta);
          } else {
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        });
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }
}
